<div>
    <div class="col-lg-4 mx-auto form-section">
        <router-outlet></router-outlet>
    </div>
</div>
